import React, { useState } from "react";
import { useLocation, matchPath } from "react-router-dom";
import SideBar from "./sidebar";
import { routes } from "../routes/routes";

const SideBarWrapper = ({ children }) => {
  const location = useLocation();
    const [isSidebarOpen, setSidebarOpen] = useState(true);
  // Find matching route, including dynamic parameters
  const currentRoute = routes.find((route) =>
    matchPath(route.path, location.pathname)
  );

  return (
<div className="flex h-screen relative">
  {currentRoute?.isSidebar && (
    <>
      <SideBar
        isSidebarOpen={isSidebarOpen}
        setSidebarOpen={setSidebarOpen}
        toggleSidebar={() => setSidebarOpen(prev => !prev)}
      />

      {/* Toggle button for mobile screens, shown only when sidebar is allowed */}
      {!isSidebarOpen&&(<div className="absolute top-2 left-2 sm:hidden z-50">
        <button
          onClick={() => setSidebarOpen(prev => !prev)}
          className="p-2 bg-gray-200 rounded-md shadow-md"
        >
          ☰
        </button>
      </div>)}
    </>
  )}

  <div className="flex-1 overflow-auto">
    {children}
  </div>
</div>

  );
};

export default SideBarWrapper;
